import React, { useCallback, useContext } from 'react'
import { FlightDropdownOption } from 'components/Flights/types'
import { fareTypes, fareCabins } from 'constants/flight'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'

import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import FareDropdownMobile from './FareDropdown/FareDropdownMobile'
import TextButton from 'components/Luxkit/Button/TextButton'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FlightSearchAirportSelectMobile from './FlightAirportSelect/FlightSearchAirportSelectMobile'
import FlightSearchTravellerSelectMobile from './FlightSearchTravellerSelectMobile'
import FlightSearchDateSelectMobile from './FlightSearchDateSelectMobile'
import Group from 'components/utils/Group'
import BusinessTravellerAccountGuard from 'businessTraveller/components/BusinessTravellerAccountGuard'
import BusinessTravellerSelectFlightsMobile from 'businessTraveller/components/select-traveller/BusinessTravellerSelectFlightsMobile'
import config from 'constants/config'
import BusinessTravellerSelectLoadingSkeleton from 'businessTraveller/components/select-traveller/BusinessTravellerSelectLoadingSkeleton'

interface Props {
  onSearchAirport: () => void;
}

function FlightSearchWidgetMobile(props: Props) {
  const state = useContext(FlightSearchWidgetStateContext)
  const dispatch = useContext(FlightSearchWidgetDispatchContext)

  const isBusinessTravellerSelectEnabled = config.businessTraveller.selectTravellerEnabled

  const { onSearchAirport } = props
  const {
    fareType,
    fareCabin,
  } = state

  const changeFareType = useCallback((fareType: FlightDropdownOption) => {
    dispatch({ type: FlightSearchWidgetActions.SET_FARE_TYPE, fareType })
  }, [dispatch])

  const changeFareCabin = useCallback((fareCabin: FlightDropdownOption) => {
    dispatch({ type: FlightSearchWidgetActions.SET_FARE_CABIN, fareCabin })
  }, [dispatch])

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSearchAirport()
  }

  return (
    <VerticalSpacer gap={12} as="form" onSubmit={onSubmit}>
      <Group direction="horizontal" gap={8}>
        <FareDropdownMobile
          options={fareTypes}
          title="Flight type"
          selectedOption={fareType}
          onOptionChange={changeFareType}
        />
        <FareDropdownMobile
          options={fareCabins}
          title="Class"
          selectedOption={fareCabin}
          onOptionChange={changeFareCabin}
        />
      </Group>
      <FlightSearchAirportSelectMobile
        isDeparture
        title="From"
      />
      <FlightSearchAirportSelectMobile
        isDeparture={false}
        title="To"
      />
      <FlightSearchDateSelectMobile />
      {isBusinessTravellerSelectEnabled && <BusinessTravellerAccountGuard
        accountMode="business"
        employeeRole="BUSINESS_ADMIN"
        LoadingComponent={() => <BusinessTravellerSelectLoadingSkeleton />}
        FallbackComponent={() => <FlightSearchTravellerSelectMobile />}
      >
        <BusinessTravellerSelectFlightsMobile />
      </BusinessTravellerAccountGuard>}
      {!isBusinessTravellerSelectEnabled && <FlightSearchTravellerSelectMobile />}
      <TextButton kind="primary" size="large" type="submit" fit="full-width">
        Search
      </TextButton>
    </VerticalSpacer>
  )
}

export default FlightSearchWidgetMobile
